// AAFES
export const REDIRECT_URL_AAFES = 'https://www.shopmyexchange.com/a/3539981';

// NEX
export const REDIRECT_URL_NEX = 'https://www.mynavyexchange.com/vendor/vendorStore.jsp?productId=14956285';

// eslint-disable-next-line max-len
export const LLC_REDIRECT_URL_SS = 'https://thdresponsive.catalogconnect.com/homedepot/suppliers/homedepot/receivecart.asp';

export const PROD_REDIRECT_URL_SS = 'https://shop.catalogconnect.com/homedepot/suppliers/homedepot/receivecart.asp';
